import React from 'react';
import { Modal, Button, Form } from '../../ui-kit';

class IntervalCommentsEditModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { comments: '' };
  }

  // Comments are copied over from the props to the state, every time the
  // interval changes. That way, we can have a local edit state of the comments,
  // before the user clicks save to actually store them. This also makes the
  // "cancel" functionality work correctly.
  componentDidUpdate = prevProps => {
    if (this.props.interval) {
      const prevIntervalId = prevProps.interval && prevProps.interval.id;
      const currIntervalId = this.props.interval && this.props.interval.id;

      if (prevIntervalId !== currIntervalId && currIntervalId) {
        this.setState({ comments: this.props.interval.comments });
      }
    } else {
      this.setState({ comments: '' });
    }
  };

  handleChange = e => {
    this.setState({ comments: e.target.value });
  };

  saveComments = () => {
    this.props.updateIntervalById(this.props.interval.id, { comments: this.state.comments });
    this.props.onHide();
  };

  render = () => (
    <Modal show={this.props.show} onHide={this.props.onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{I18n.t('edit_comments')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Control
            as="textarea"
            value={this.state.comments}
            onChange={this.handleChange}
            style={{ height: 150 }}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={this.props.onHide}>{I18n.t('cancel')}</Button>
        <Button onClick={this.saveComments} variant="primary">
          {I18n.t('save')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default IntervalCommentsEditModal;
